import {useQuery} from '@tanstack/react-query'

import {getFleetUtilization} from './api'
import {dashboardKeys} from './query-keys'

export function useFleetUtilization(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: dashboardKeys.fleetUtilization(),
        queryFn: getFleetUtilization,
        enabled: options?.enabled ?? true,
    })
}
